import './PollutionMap.scss';

import { FC } from 'react';
import { Map, GoogleApiWrapper, IProvidedProps, Circle } from 'google-maps-react';

import { Point } from '../../types';
import findCenter from '../../utilities/findCenter';

interface MapContainerProps {
  points: Point[];
}

const LoadingContainer: FC = () => {
  return (
    <div />
  );
};

const MapContainer: FC<IProvidedProps & MapContainerProps> = ({ points, google }) => {
  const bounds = new google.maps.LatLngBounds();
  for (let j = 0; j < points.length; j++) {
    bounds.extend(points[j]);
  }

  const getColor = (co2: number) => {
    if (co2 <= 25) return "#68F7B7";
    if (co2 <= 50) return "#FBA542";
    return "#eb4034";
  };

  return (
    <div className="map">
      <Map
        google={google}
        initialCenter={findCenter(points)}
        bounds={bounds}
        // @ts-ignore
        mapTypeControl={false}
        streetViewControl={false}
        fullscreenControl={false}
        keyboardShortcuts={false}
        zoom={15}
      >
        <div className="info">
          <div className="info__title">Indexe du taux de CO2 (mg / m^3)</div>
          <div className="info__menu-item">
            <div className="info__menu-item__sign" style={{ backgroundColor: '#68F7B7' }}></div>
            <div className="info__menu-item__label">Taux inférieur à 25</div>
          </div>
          <div className="info__menu-item">
            <div className="info__menu-item__sign" style={{ backgroundColor: '#FBA542' }}></div>
            <div className="info__menu-item__label">Taux inférieur à 50</div>
          </div>
          <div className="info__menu-item">
            <div className="info__menu-item__sign" style={{ backgroundColor: '#eb4034' }}></div>
            <div className="info__menu-item__label">Taux supérieur à 50</div>
          </div>
        </div>
        {points.map(point => (
          <Circle
            radius={80}
            center={{ lng: point.lng, lat: point.lat }}
            strokeColor='transparent'
            strokeWeight={5}
            fillColor={getColor(point.co2)}
          />
        ))}
      </Map>
    </div>
  );
};

export default GoogleApiWrapper(props => ({
  apiKey: process.env.REACT_APP_API_KEY,
  LoadingContainer: LoadingContainer,
  ...props
}))(MapContainer);
